import { render, staticRenderFns } from "./adminusercenter.vue?vue&type=template&id=32a6ad9e&"
import script from "./adminusercenter.vue?vue&type=script&lang=js&"
export * from "./adminusercenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports